export class HeaderHelper {
  static formatHeaders(
    headers: string,
    fileType: string,
    fileName?: string
  ): Record<string, string> {
    if (!headers) {
      return null;
    }
    const headersRecord: Record<string, string> = headers
      .split(',')
      .reduce((headerRecord: Record<string, string>, currentHeader: string) => {
        const splitCurrentHeader: string[] = currentHeader.split(':');
        headerRecord[splitCurrentHeader[0]] = splitCurrentHeader[1];
        return headerRecord;
      }, {});

    let lastDotIndex: number = fileName?.lastIndexOf('.');
    const extension: string = fileName?.slice(++lastDotIndex);

    const contentType: string = extension === 'key' ? 'application/vnd.apple.keynote' : fileType;
    headersRecord['Content-Type'] = contentType;
    return headersRecord;
  }
}
